import React, {useState, useRef, useEffect} from 'react';
import { connect } from "react-redux";
import {AccessRights} from "../../schemas/accessRightsModel";
import {POST_MESSAGES} from "../../constants/dashboard";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "../VisualizerManagement/VisualizerManagement";
import {getJobEditIframeUrl} from "./getJobIframeUrl";
import {hasSubscriptions} from "../../utilities/subscriptionFunctions";

const JobBoardEditIframe = (props) => {

  const {language, auth, asCustomer, editableQuote, editableQuoteShow, showEditable, AR, signedRequestId,
    allSubscriptions} = props;
  const [iframeSrc, setIframeSrc] = useState("");
  const [iframeIsLoading, setIframeIsLoading] = useState(true);
  const iframeElement = useRef(null);

  const setLoading = (event) => {
    if (event && event.data && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.visualizerIsLoaded)) {
      setIframeIsLoading(false)
    }
  }

  useEffect(() => {
    window.addEventListener("message", setLoading);
    return () => {
      window.removeEventListener("message", setLoading);
    }
  })

  const setQuoteEditUrl = async () => {
    setIframeSrc(await getJobEditIframeUrl(
      editableQuote,
      asCustomer,
      auth,
      AR,
      language,
      editableQuoteShow,
      showEditable,
      signedRequestId,
      allSubscriptions
    ));
  };

  useEffect(() => {
    setQuoteEditUrl();
  }, []);

  useEffect(() => {
    if (iframeSrc && iframeElement && iframeElement.current && iframeElement.current.contentWindow && iframeElement.current.contentWindow.postMessage) {
      // console.log("outgoing language", language);
      iframeElement.current.contentWindow.postMessage({
        action: POST_MESSAGES.setIframeLanguage,
        payload: { language }
      }, iframeSrc);
    }
  }, [language]);

  return (
    <div className="quote-adj-wrapper">
      <div className="quote-adj-container">
        <div className="quote-adj-iframe-container">
          <div className="quote-adj-iframe-border">
            <iframe className={"quote-adj-iframe" + (iframeIsLoading ? " quote-adj-iframe--loading" : "")}
                    src={iframeSrc}
                    ref={iframeElement} />
            {iframeIsLoading ? <div className="ui-loader"/> : null}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (state) => {
  const {auth, asCustomer, dashboardState, jobBoard} = state;
  const {allSubscriptions} = hasSubscriptions(state);

  return {
    auth,
    asCustomer,
    AR: AccessRights.get(state),
    editableQuote: jobBoard.editableQuote,
    editableQuoteShow: jobBoard.editableQuoteShow,
    language: dashboardState.language,
    allSubscriptions,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardEditIframe)
